import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api, TaskRow } from "../lib/api";

export function Dashboard() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["tasks"],
    queryFn: () => api<TaskRow[]>("/api/tasks"),
    refetchInterval: 5_000,
  });

  if (isLoading) {
    return <p className="text-sm text-slate-500">Loading tasks…</p>;
  }
  if (error) {
    return (
      <p className="text-sm text-rose-700">
        Failed to load tasks: {(error as Error).message}
      </p>
    );
  }
  if (!data || data.length === 0) {
    return (
      <div className="rounded border border-dashed border-slate-300 p-8 text-center">
        <p className="text-slate-600">
          No tasks yet. Dispatch an agent with{" "}
          <code className="bg-slate-100 px-1 rounded">
            SWARM_TRACE_ENDPOINT
          </code>{" "}
          set and traces will appear here.
        </p>
      </div>
    );
  }
  return (
    <div className="space-y-4">
      <h1 className="text-lg font-semibold">Tasks</h1>
      <div className="overflow-hidden rounded border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              <th className="text-left px-4 py-2 font-medium">Task</th>
              <th className="text-right px-4 py-2 font-medium">Runs</th>
              <th className="text-right px-4 py-2 font-medium">Active</th>
              <th className="text-right px-4 py-2 font-medium">Last seen</th>
            </tr>
          </thead>
          <tbody>
            {data.map((t) => (
              <tr
                key={t.id}
                className="border-t border-slate-100 hover:bg-slate-50"
              >
                <td className="px-4 py-2">
                  <Link
                    to={`/tasks/${encodeURIComponent(t.id)}`}
                    className="text-blue-700 hover:underline font-mono"
                  >
                    {t.id}
                  </Link>
                </td>
                <td className="text-right px-4 py-2 tabular-nums">
                  {t.runs_count}
                </td>
                <td className="text-right px-4 py-2 tabular-nums">
                  {t.active_runs > 0 ? (
                    <span className="text-blue-700 font-medium">
                      {t.active_runs}
                    </span>
                  ) : (
                    <span className="text-slate-400">0</span>
                  )}
                </td>
                <td className="text-right px-4 py-2 text-slate-500 text-xs">
                  {fmtDate(t.last_seen_at)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function fmtDate(iso: string): string {
  const d = new Date(iso);
  if (isNaN(+d)) return iso;
  return d.toLocaleString();
}
